import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/app/providers/AuthProvider';
import { HubId, PermissionsHelper } from '@/types/permissions';
import { HubMaintenanceGate } from '@/components/maintenance/HubMaintenanceGate';

interface RequireHubAccessProps {
  hubId: HubId;
  children: React.ReactElement;
}

/**
 * @deprecated Usare RequireScope con scope="view:hub:{hubId}" invece
 * 
 * Componente di protezione route per accesso Hub
 * Verifica se l'utente può vedere un hub specifico
 * 
 * Questo componente è deprecato in favore di RequireScope che supporta
 * un sistema di permessi più granulare basato su scopes.
 * 
 * Migrazione:
 * <RequireHubAccess hubId="business"> → <RequireScope scope="view:hub:business">
 */
const RequireHubAccess: React.FC<RequireHubAccessProps> = ({ hubId, children }) => {
  const { user, loading, canViewHub } = useAuth();

  // Mostra loader durante la verifica
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-white to-zinc-50 dark:from-zinc-900 dark:to-zinc-800">
        <div className="w-12 h-12 border-3 border-zinc-200 dark:border-zinc-700 border-t-zinc-600 dark:border-t-zinc-400 rounded-full animate-spin"></div>
      </div>
    );
  }

  // Utente non autenticato - redirect al login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Verifica permessi Hub usando canViewHub dal context (include fix temporanei)
  if (!canViewHub(hubId)) {
    return <Navigate to="/forbidden" replace />;
  }

  // Utente ha accesso al hub - mostra contenuto
  return <HubMaintenanceGate hubId={hubId}>{children}</HubMaintenanceGate>;
};

export default RequireHubAccess;
